import { createFileRoute } from '@tanstack/react-router'
import { StaffOverview } from '../../../../components/StaffOverview'

export const Route = createFileRoute('/platform/desa/$desaId/')({
  component: () => {
    const { desaId } = Route.useParams()
    return <StaffOverview desaId={desaId} />
  },
})
